export default __webpack_public_path__ + "static/media/location.d7f06663.png";